<template>
  <component
    :is="component"
    v-bind="$props"
    v-on="$listeners"
  />
</template>

<script>
import ShiftWorkerSelectorSelect from './ShiftWorkerSelectorSelect.vue'
import ShiftWorkerSelectorButtons from './ShiftWorkerSelectorButtons.vue'

export default {
  props: {
    type: {
      type: String,
      default: 'select',
      validator: value => ['select', 'buttons'].includes(value),
    },
    selectedOption: {
      type: Object,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    hasSelectableOptions: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    component() {
      return this.type === 'buttons' ? ShiftWorkerSelectorButtons : ShiftWorkerSelectorSelect
    },
  },
}
</script>
